module.exports = __webpack_public_path__ + "img/setup-2.50ae5831.png";